import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { connect } from 'react-redux'
import { Text } from '@amzn/dvui/dist/Text'
import { PrimaryButton } from '@amzn/dvui/dist/Button'
import * as st from './otherFormats.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { DpWidgetContext } from '../../utils/dpWidgetContext'
import { Container } from '@amzn/dvui/dist/Container'
import { IDetailPageState } from '../../reducers'
import { showOtherFormatsSelector } from '../../selectors/otherFormats'
import { pageSelectors } from '../../selectors/basicState'

export interface IOtherFormatsProps {
  showOtherFormats: boolean,
  otherFormats?: WpsRuntime.atv.wps.OtherFormatsModelProps
}

export const ConnectedOtherFormats = ({otherFormats, showOtherFormats}: IOtherFormatsProps) => {
  const { getString } = React.useContext(DpWidgetContext)
  if (!showOtherFormats || !otherFormats) {
    return null
  }

  return <Container className={stUtility.pageSection}>
    <div data-automation-id="other-formats">
      <h1 className={st.header}> {getString('DV_DP_CL_other_formats_title')} </h1>
      {otherFormats.actions.map((action: WpsRuntime.atv.wps.FormatActionProps, idx) => {
        return <div className={st.otherFormats} key={`other-format-${idx}`}>
          <PrimaryButton href={action.link} forceDoubleHeight={true}>
            <Text tag="span" string={action.text}/>
          </PrimaryButton>
        </div>
      })}
    </div>
  </Container>
}

const mapStateToProps = (state: IDetailPageState): IOtherFormatsProps => ({
  showOtherFormats: showOtherFormatsSelector(state),
  otherFormats: pageSelectors.otherFormats(state),
})

export const OtherFormats = connect(mapStateToProps)(
  ConnectedOtherFormats
)
